import { ThemeContext } from "@emotion/react";
import { Backdrop, Box, Button, Checkbox, Fade, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Modal, Select, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { CertificadoPregunta } from "./pregunta";
import { GetAllStandarsList } from "../../../../../hooks/getStandarsList";
import { set } from "react-hook-form";
import { PreguntasEnum } from "../../../../../@enums/tipo_pregunta.enum";
import { CreateCuestionarioRework } from "../../../../../hooks/cuestionarios";
import { useLoading } from "../../../../../components/Loading/useLoading";
import { useSnackbar } from "notistack";
import { Delete } from "@mui/icons-material";

const TIPO_REPETICION = [
  { label: 'Turno', value: 1 },
  { label: 'Semanal', value: 2 },
]

export const ModalCertificado = ({ open, setOpen, alma_id }) => {

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    maxWidth: 1000,
    minWidth: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 2,
    pt: 3,
    display: 'flex',
    justifyContent: 'center',
    maxHeight: 550,
    overflowY: 'scroll'
  };

  const formCreate = useRef(null);
  const { setAppLoading } = useLoading();
  const theme = useContext(ThemeContext);
  const { enqueueSnackbar } = useSnackbar();
  const { getAllStandarsListMutation } = GetAllStandarsList();
  const { createCuestionarioReworkMutation } = CreateCuestionarioRework();
  const [errorName, setErrorName] = useState(false);
  const [standars, setStandars] = useState([]);
  const [preguntas, setPreguntas] = useState([]);
  const [secciones, setSecciones] = useState([]);
  const [repeticion, setRepeticion] = useState(null);
  const [diasSemana, setDiasSemana] = useState([]);

  const getStandars = () => {
    getAllStandarsListMutation({}, {
      onSuccess: (data) => {
        setStandars(data);
      },
      onError: (error) => {
        console.log(error);
      }
    })
  }

  useEffect(() => {
    getStandars();
  }, []);


  const onSave = (body) => {
    setAppLoading(true);
    console.log({ id: alma_id, body });
    createCuestionarioReworkMutation({ id: alma_id, body }, {
      onSuccess: () => {
        enqueueSnackbar("Certificado creado con exito", {
          autoHideDuration: 2000,
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
        handleClose();
      },
      onError: (error) => {
        console.log(error);
        enqueueSnackbar("Error al crear el certificado", {
          autoHideDuration: 2000,
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
        });
      },
      onSettled: () => {
        setAppLoading(false);
      }
    })
  }

  const validateSecciones = () => {
    if (secciones.length > 0) {
      let exist_null = secciones.some(seccion => {
        return seccion.preguntas.some((preg) => {
          return preg.cupe_tipo === null || preg.stand_id === undefined;
        })
      })

      return exist_null;
    }
    return false;
  }
  const validatePreguntas = () => {
    if (preguntas.length > 0) {
      let exist_null = preguntas.some((preg) => {
        return preg.cupe_tipo === null || preg.stand_id === undefined;
      })
      return exist_null;
    }
    return false;
  }

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let validate_secciones = validateSecciones();
    let validate_preguntas = validatePreguntas();
    if (validate_secciones || validate_preguntas) {
      return false;
    } else {
      let cuestionario = {
        cues_nombre: formCreate.current.cues_nombre.value,
        cues_descripcion: formCreate.current.cues_descripcion.value,
        cues_tipo_repeticion: repeticion,
        cues_frecuencia_turno: repeticion === 1 ? +formCreate.current.cues_frecuencia_turno.value : null,
        cues_dias_semana: repeticion === 2 ? JSON.stringify(diasSemana) : null,
      }
      let seccionesData = [...secciones];
      let preguntasData = [...preguntas];

      let body = {
        cuestionario,
        preguntas: preguntasData,
        secciones: seccionesData
      }
      onSave(body);
    }
  }

  const onChangeWeekDays = (weekday) => {
    let diasTemp = [...diasSemana];
    if (diasTemp.includes(weekday)) {
      diasTemp = diasTemp.filter(dia => dia !== weekday);
    } else {
      diasTemp.push(weekday);
    }
    setDiasSemana(diasTemp);
  }

  const addSeccion = () => {
    let preg = [...preguntas];
    console.log(preg);
    let seccion = {
      cuse_nombre: null,
      cuse_descripcion: null,
      preguntas: preg
    }
    console.log(seccion);
    setSecciones([...secciones, seccion]);
    setPreguntas([]);
  }

  const changeDataSeccion = (index, field, value) => {
    let seccionesTemp = [...secciones];
    seccionesTemp[index][field] = value;
    setSecciones(seccionesTemp);
  }

  const changeDataPregunta = (indexSeccion, indexPregunta, field, value) => {
    if (indexSeccion === null) {
      let preguntasTemp = [...preguntas];
      preguntasTemp[indexPregunta][field] = value;
      setPreguntas(preguntasTemp);
    } else {
      let seccionesTemp = [...secciones];
      seccionesTemp[indexSeccion].preguntas[indexPregunta][field] = value;
      setSecciones(seccionesTemp);
    }
  }

  const addPregunta = () => {
    let pregunta = {
      cupe_pregunta: null,
      cupe_descripcion: null,
      cupe_tipo: null,
      cupe_multiple: false,
      cupe_opciones: null,
      cupe_valorprellenado: null,
      stand_id: null
    }
    if (secciones.length === 0) {
      setPreguntas([...preguntas, pregunta]);
    } else {
      let seccionesTemp = [...secciones];
      seccionesTemp[seccionesTemp.length - 1].preguntas.push(pregunta);
      setSecciones(seccionesTemp);
    }
  }
  const addPreguntaSeccion = (indexSeccion) => {
    let pregunta = {
      cupe_pregunta: null,
      cupe_descripcion: null,
      cupe_tipo: null,
      cupe_multiple: false,
      cupe_opciones: null,
      cupe_valorprellenado: null,
      stand_id: null
    }
    let seccionesTemp = [...secciones];
    seccionesTemp[indexSeccion].preguntas.push(pregunta);
    setSecciones(seccionesTemp);
  }
  const deletePregunta = (indexPregunta, indexSeccion) => {
    if (secciones.length === 0) {
      let preguntasTemp = [...preguntas];
      preguntasTemp.splice(indexPregunta, 1);
      setPreguntas(preguntasTemp);
    } else {
      let seccionesTemp = [...secciones];
      seccionesTemp[indexSeccion].preguntas.splice(indexPregunta, 1);
      setSecciones(seccionesTemp);
    }
  }
  const deleteSeccion = (index) => {
    let seccionesTemp = [...secciones];
    seccionesTemp.splice(index, 1);
    setSecciones(seccionesTemp);
  }

  const handleClose = () => {
    setPreguntas([]);
    setSecciones([]);
    setRepeticion(null);
    setDiasSemana([]);
    setOpen(false)
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          timeout: 500,
        },
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <form ref={formCreate} onSubmit={onSubmit}>
            <Grid container spacing={0}>
              <Grid item xs={12} sx={{ p: 0, textAlign: 'center' }} >
                <Typography id="transition-modal-title" variant="h6" component="h2">
                  Nuevo Check de Línea
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ p: 2, mt: 2, textAlign: 'start' }} >
                <TextField
                  id="cues_nombre"
                  label="Nombre del Check de Línea"
                  name="cues_nombre"
                  size="small"
                  fullWidth
                  required
                  onChange={(e) => {
                    e.target.value.length > 0 ?
                      setErrorName(false) :
                      setErrorName(true)
                  }}
                  sx={{ color: theme.palette.primary.input }}
                  error={errorName}
                  helperText={errorName ? 'Ingrese un valor' : ''}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <TextField
                  id="cues_descripcion"
                  label="Descripción del Check de Línea"
                  name="cues_descripcion"
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  sx={{ color: theme.palette.primary.input }}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <TextField
                  id="cues_observaciones"
                  label="Observaciones"
                  name="cues_observaciones"
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  sx={{ color: theme.palette.primary.input }}
                />
              </Grid>
              <Grid item xs={12} sx={{ p: 2, textAlign: 'left' }} >
                <Typography id="transition-modal-title" variant="h8" component="h3">
                  Frecuencia
                </Typography>
              </Grid>
              <Grid item xs={6} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <FormControl fullWidth required error={repeticion === null}>
                  <InputLabel id="tipo_repeticion_label">Tipo de frecuencia</InputLabel>
                  <Select
                    labelId={`tipo_repeticion_label`}
                    id={`tipo_repeticion`}
                    name={`tipo_repeticion`}
                    label={`Tipo de repetición`}
                    required
                    size="small"
                    fullWidth
                    value={repeticion}
                    onChange={(e) => {
                      setRepeticion(e.target.value);
                      setDiasSemana([]);
                    }}
                    error={repeticion === null}
                  // sx={{ color: theme.palette.primary.input }}
                  >
                    {
                      TIPO_REPETICION.map((option) => (
                        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                      ))
                    }
                  </Select>
                  <FormHelperText>{repeticion === null ? 'Seleccione un tipo de repetición' : ''}</FormHelperText>
                </FormControl>
              </Grid>
              {
                repeticion === 1 && (
                  <Grid item xs={6} sx={{ p: 2, mt: -2, textAlign: 'start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', height: '100%' }}>
                      <Typography id="transition-modal-title" variant="h8" component="h4" sx={{ m: 0, p: 0 }}>
                        Veces por turno:
                      </Typography>
                      <TextField
                        id="cues_frecuencia_turno"
                        name="cues_frecuencia_turno"
                        label=""
                        type="number"
                        size="small"
                        required
                        inputProps={{ min: 1, max: 5 }}
                        sx={{ color: theme.palette.primary.input }}
                      />
                    </div>
                  </Grid>
                )
              }
              {
                repeticion === 2 && (
                  <Grid item xs={6} sx={{ p: 2, mt: -2, textAlign: 'start' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 10, alignItems: 'center', height: '100%' }}>
                      <Typography id="transition-modal-title" variant="h8" component="h4" sx={{ m: 0, p: 0 }}>
                        Dias de la semana:
                      </Typography>
                      <FormGroup row>
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(1)} onChange={(e) => onChangeWeekDays(1)} />} label="L" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(2)} onChange={(e) => onChangeWeekDays(2)} />} label="M" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(3)} onChange={(e) => onChangeWeekDays(3)} />} label="M" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(4)} onChange={(e) => onChangeWeekDays(4)} />} label="J" />
                        <FormControlLabel control={<Checkbox checked={diasSemana.includes(5)} onChange={(e) => onChangeWeekDays(5)} />} label="V" />
                      </FormGroup>
                    </div>
                  </Grid>
                )
              }
              {
                secciones && secciones.map((seccion, index) => (
                  <div key={`sec_${index}_${secciones.length}`} style={{ width: '100%' }}>
                    <Grid item xs={12} sx={{ p: 2, textAlign: 'start', display: 'flex', flexDirection: 'row', alignItems: 'center' }} >
                      <Typography id="transition-modal-title" variant="h8" component="h4">
                        Sección {index + 1}
                      </Typography>
                      <IconButton
                        size="large"
                        sx={{ ml: 1 }}
                        onClick={() => deleteSeccion(index)}>
                        <Delete sx={{ fontSize: 25 }} />
                      </IconButton>
                    </Grid>
                    <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                      <TextField
                        id={`cuse_nombre_${index}`}
                        label="Nombre de sección"
                        name={`cuse_nombre_${index}`}
                        size="small"
                        fullWidth
                        required
                        defaultValue={seccion.cuse_nombre}
                        sx={{ color: theme.palette.primary.input }}
                        onChange={(e) => changeDataSeccion(index, "cuse_nombre", e.target.value)}
                        error={seccion?.cuse_nombre === null || seccion?.cuse_nombre === ''}
                        helperText={seccion?.cuse_nombre === null || seccion?.cuse_nombre === '' ? 'Ingrese un valor' : ''}
                      />
                    </Grid>
                    <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                      <Button variant="contained"
                        className="btn_system"
                        onClick={() => addPreguntaSeccion(index)}
                      >
                        Nueva Pregunta
                      </Button>
                    </Grid>
                    <div key={`preg_${index}_${seccion.preguntas.length}`} style={{ width: '100%' }}>
                      {
                        seccion.preguntas && seccion.preguntas.map((pregunta, indexPregunta) => (
                          <CertificadoPregunta
                            key={`sec_${index}_pre_${indexPregunta}`}
                            pregunta={pregunta}
                            index={indexPregunta}
                            padding={4}
                            indexSeccion={index}
                            changeDataPregunta={changeDataPregunta}
                            standars={standars}
                            deletePregunta={deletePregunta}
                          />
                        ))
                      }
                    </div>
                  </div>
                ))
              }
              {
                preguntas && preguntas.map((pregunta, index) => (
                  <CertificadoPregunta
                    key={`ns_pre_${index}`}
                    pregunta={pregunta}
                    index={index}
                    padding={4}
                    indexSeccion={null}
                    changeDataPregunta={changeDataPregunta}
                    standars={standars}
                    deletePregunta={deletePregunta}
                  />
                ))
              }
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <Button variant="contained"
                  className="btn_system"
                  onClick={addSeccion}
                  disabled={secciones.length > 0 && secciones[secciones.length - 1].preguntas.length === 0}
                >
                  Nueva Sección
                </Button>
              </Grid>
              {
                secciones?.length === 0 && (
                  <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                    <Button variant="contained"
                      className="btn_system"
                      onClick={addPregunta}
                    >
                      Nueva Pregunta
                    </Button>
                  </Grid>
                )
              }
              <Grid item xs={12} sx={{ p: 2, mt: -2, textAlign: 'start' }} >
                <Button variant="contained"
                  className="btn_system"
                  type="submit"
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Fade>
    </Modal>
  );
}